import '../../types/window-augmentations';

// Dupe of same function from conversation-assistant
// No need to add a whole dependency just for this function
export const setRovoChatProduct = (product: string): void => {
	if (window) {
		window.__ROVO_CHAT_CONFIG_PRODUCT__ = product;
	}
};
